insightHandler = {
    $insightContent = $('.insight-content'),
    $insigthsTitle = $('.insigths-title'),
    $insightItemContainer = $('.insight-item-container'),
    $gridInsight = $('.grid-insight'),
    $window = $(window),
    isOnLoad = false,
    lastWindowWidth = $window.width(),
    resizeTimeout = null,

    showinsightImage = function(id, show=false) {
        $('.insight-image-container[data-id='+id+']').each(function() {
            if (show) {
                $(this).addClass('show-image');
            } else {
                $(this).removeClass('show-image');
            }
        });
    },

    init = function(){
        var self = this;
        this.isOnLoad = true;
        
        if (Foundation.MediaQuery.atLeast('medium')) {
            self.$insightContent.on('mouseover', function(e) {
                e.preventDefault();
                var id = $(this).data('id');
                self.showinsightImage(id, true);
            });

            self.$insightContent.on('mouseout', function(e) {
                e.preventDefault();
                var id = $(this).data('id');
                self.showinsightImage(id);
                
            });
        }
        
        animateHandler.animateScroll( this.$insigthsTitle ); 
        animateHandler.animateParallax( this.$gridInsight );
       
        this.$window.resize(function(){
            clearTimeout(self.resizeTimeout);
            self.resizeTimeout = setTimeout(function() {
                if (self.isOnLoad) {
                    self.isOnLoad = false;   
                } else {
                    var windowWidth = $window.width();
                    if (windowWidth != self.lastWindowWidth) {
                        animateHandler.animateScroll( $insigthsTitle, 1, true ); 
                        self.lastWindowWidth = windowWidth;
                    }
                }   
            }, 25);
        });

    }
}